module.exports = __webpack_public_path__ + "media/images/entidades_organizadoras/uniao_europeia-0915cc3ba626fe0fa64a879c57f75c0c.svg";